import { useState } from "react";

export default function BlockText({ block, setBlocks, updateBlock, className, isEditing, settingsFunnel }) {

    if(block.content == null){
        block.content = '<script>console.log("Hello World");</script>';
    }
 
 
    if(!isEditing){
        try{
 
            // Safely execute the script content by injecting it as a <script> tag
            if (typeof window !== "undefined" && block.content) {
                // Remove any previous script with this id
                const scriptId = `block-script-${block.id}`;
                const oldScript = document.getElementById(scriptId);
                if (oldScript) oldScript.remove();

                // Extract the JS code from <script>...</script>
                const match = block.content.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
                const jsCode = match ? match[1] : block.content;

                const script = document.createElement("script");
                script.id = scriptId;
                script.type = "text/javascript";
                script.text = jsCode;
                document.body.appendChild(script);
            }
            }catch(e){
                console.log(e);
            }
    }
    
    return (
      <div className={`rounded-xl w-full ${className || ''}`} style={{display: !isEditing ? 'none' : 'block'}}> 
        <div className="w-full">
          <div id={`script-${block.id}`}
            className="text-sm bg-gray-900 text-green-500 p-2 rounded-lg" 
             
          >
           
                {String(block.content)}
           </div>
        </div>
      </div>
    );
  
}